<mat-checkbox
  color="primary"
  [(ngModel)]="checkBool"
  (change)="change($event)"
></mat-checkbox>
